import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

/* Blocking screen shown on first login when the account is on a temporary
   password. The user must set their own before reaching the app. */
export default function ForceChangePassword() {
  const { user, setUser, logout } = useAuth();
  const [pw, setPw] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setErr('');
    if (pw.length < 8) { setErr('Password must be at least 8 characters.'); return; }
    if (pw !== confirm) { setErr('Passwords don’t match.'); return; }
    setSaving(true);
    try {
      await api.post('/auth/change-password', { newPassword: pw });
      const updated = { ...user, must_change_password: false };
      localStorage.setItem('user', JSON.stringify(updated));
      setUser(updated);   // clears the gate → app renders
    } catch (e2) {
      setErr(e2.response?.data?.error || 'Could not update your password. Please try again.');
    } finally { setSaving(false); }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg, #0B1F2E)', padding: 20 }}>
      <div style={{ width: '100%', maxWidth: 380, background: '#fff', borderRadius: 14, padding: 28, boxShadow: '0 10px 40px rgba(0,0,0,0.25)' }}>
        <h1 style={{ margin: '0 0 6px', fontSize: 20, fontWeight: 700, color: '#111' }}>Set your password</h1>
        <p style={{ margin: '0 0 20px', fontSize: 13.5, color: '#6b7280', lineHeight: 1.5 }}>
          Welcome{user?.full_name ? `, ${user.full_name.split(' ')[0]}` : ''}. You’re signed in with a temporary
          password — please choose your own to continue.
        </p>
        <form onSubmit={submit}>
          <label style={{ display: 'block', fontSize: 12.5, fontWeight: 600, color: '#374151', marginBottom: 4 }}>New password</label>
          <input type="password" value={pw} onChange={e => setPw(e.target.value)} autoFocus autoComplete="new-password"
            style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, marginBottom: 14, boxSizing: 'border-box' }} />
          <label style={{ display: 'block', fontSize: 12.5, fontWeight: 600, color: '#374151', marginBottom: 4 }}>Confirm password</label>
          <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)} autoComplete="new-password"
            onKeyDown={e => { if (e.key === 'Enter') submit(e); }}
            style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, marginBottom: 6, boxSizing: 'border-box' }} />
          <div style={{ fontSize: 11.5, color: '#9ca3af', marginBottom: 14 }}>At least 8 characters.</div>
          {err && <div style={{ fontSize: 12.5, color: '#B3261E', marginBottom: 12 }}>{err}</div>}
          <button type="submit" disabled={saving || !pw || !confirm}
            style={{ width: '100%', padding: '11px', background: saving ? '#9ca3af' : '#0B1F2E', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: saving ? 'default' : 'pointer' }}>
            {saving ? 'Saving…' : 'Set password & continue'}
          </button>
        </form>
        <button onClick={logout}
          style={{ width: '100%', marginTop: 10, padding: '8px', background: 'none', border: 'none', color: '#6b7280', fontSize: 12.5, cursor: 'pointer' }}>
          Sign out
        </button>
      </div>
    </div>
  );
}
